import React from 'react';
import { Outlet } from 'react-router-dom';
import AuthProvider from '../context/auth-provider';
import AdminHeader from '../components/AdminHeader';

const AdminLayout = () => (
  <AuthProvider>
    <AdminHeader />
    <Outlet />
  </AuthProvider>
);

export default AdminLayout;